<template>
    <jt-form
        :alertType="alert.type"
        :alertShow="alert.show"
        :alertMessage="alert.message"
        v-on:create="create()"
        v-on:closeAlert="closeAlert()"
        v-on:clear="clear()"
        title="Nova duplicata a pagar"
    >
        <div class="form-row">
            <div class="col-12 col-md-3">
                <b-form-group
                    label="Documento"
                >
                    <b-form-input
                        type="text"
                        placeholder="Documento"
                        v-model="form.doc"
                        size="sm"
                    />
                    <small v-if="!$v.form.doc.required" >Campo requerido</small>
                    <small v-else-if="!$v.form.doc.numeric" >Campo precisa ser numérico</small>
                </b-form-group>
            </div>
            <div class="col-12 col-md-3">
                <b-form-group
                    label="Nº Parcela"
                >
                    <b-form-input
                        type="text"
                        placeholder="Nº Parcela"
                        v-model="form.parcela"
                        size="sm"
                    />
                    <small v-if="!$v.form.parcela.required" >Campo requerido</small>
                    <small v-if="!$v.form.parcela.numeric" >Campo precisa ser numérico</small>
                </b-form-group>
            </div>
            <div class="col-12 col-md-3">
                <b-form-group
                    label="Nº Série"
                >
                    <b-form-input
                        type="text"
                        placeholder="Nº Série"
                        v-model="form.serie"
                        size="sm"
                    />
                    <small v-if="!$v.form.serie.required" >Campo requerido</small>
                </b-form-group>
            </div>
            <div class="col-12 col-md-3">
                <b-form-group
                    label="Situação"
                >
                    <b-form-input
                        type="text"
                        placeholder="Situação"
                        v-model="form.situacao"
                        size="sm"
                    />
                </b-form-group>
            </div>
        </div>

        <div class="form-row">
            <div class="col-12 col-md-4">
                <b-form-group
                    label="Fornecedor"
                >
                    <v-select 
                        :options="fornecedores" 
                        v-model="form.agente"
                        :searchable="true" 
                        textProp="descricao"
                        valueProp="id"
                        labelNotFound="Nenhum valor encontrado."
                    />

                    <small v-if="!$v.form.agente.required" >Campo requerido</small>
                </b-form-group>
            </div>
            <div class="col-12 col-md-4">
                <b-form-group
                    label="Conta Financeira"
                >
                    <v-select 
                        :options="contas" 
                        v-model="form.conta"
                        :searchable="true" 
                        textProp="descricao"
                        valueProp="id"
                        labelNotFound="Nenhum valor encontrado."
                    />
                </b-form-group>
            </div>
            <div class="col-12 col-md-4">
                <b-form-group
                    label="Centro de custo"
                >
                    <v-select 
                        :options="ccustos" 
                        v-model="form.ccusto"
                        :searchable="true" 
                        textProp="descricao"
                        valueProp="id"
                        labelNotFound="Nenhum valor encontrado."
                    />
                </b-form-group>
            </div>
        </div>

        <div class="form-row">
            <div class="col-12 col-md-4">
                <b-form-group
                    label="Emissão"
                >
                    <b-form-datepicker 
                        placeholder="Data do caixa" 
                        size="sm" 
                        v-model="form.emissao" 
                        locale="pt-br"
                    />
                </b-form-group>
            </div>
            <div class="col-12 col-md-4">
                <b-form-group
                    label="Vencimento"
                >
                    <b-form-datepicker 
                        placeholder="Data de vencimento" 
                        size="sm" 
                        v-model="form.vencimento" 
                        locale="pt-br"
                    />
                </b-form-group>
            </div>
            <div class="col-12 col-md-4">
                <b-form-group
                    label="Previsão"
                >
                    <b-form-datepicker 
                        placeholder="Data de previsao" 
                        size="sm" 
                        v-model="form.previsao" 
                        locale="pt-br"
                    />
                </b-form-group>
            </div>
        </div>

        <div class="form-row">
            <div class="col-12 col-md-4">
                <b-form-group
                    label="Tipo do documento"
                >
                    <v-select 
                        :options="tipodocs" 
                        v-model="form.tipodoc"
                        :searchable="true" 
                        textProp="descricao"
                        valueProp="id"
                        labelNotFound="Nenhum valor encontrado."
                    />
                </b-form-group>
            </div>
            <div class="col-12 col-md-4">
                <input-moeda
                    v-model="form.valor"
                    texto="Valor da conta"
                    titulo="Valor"
                >
                    <small v-if="!$v.form.valor.required" >Campo requerido</small>
                </input-moeda>
            </div>
            <div class="col-12 col-md-4">
                <input-moeda
                    v-model="form.valorpago"
                    texto="Valor pago"
                    titulo="Valor pago"
                >
                    <small v-if="!$v.form.valorpago.required" >Campo requerido</small>
                </input-moeda>
            </div>
        </div>

        <div class="form-row">
            <div class="col-12 col-md-6">
                <input-moeda
                    v-model="form.juros"
                    texto="Juros"
                    titulo="Juros"
                >
                    <small v-if="!$v.form.juros.required" >Campo requerido</small>
                </input-moeda>
            </div>
            <div class="col-12 col-md-6">
                <input-moeda
                    v-model="form.mora"
                    texto="Mora"
                    titulo="Mora"
                >
                </input-moeda>
            </div>
        </div>
    </jt-form>
</template>
<script>
import { 
    required, 
    numeric
} from 'vuelidate/lib/validators'

import jtForm from '@/components/form.vue'
import VSelect from '@alfsnd/vue-bootstrap-select'
import inputMoeda from '@/components/inputMoeda.vue'
export default {
    name: 'vwNewPay',
    data(){
        return {
            form: {
                doc: null,
                emissao: null,
                vencimento: null,
                previsao: null,
                agente: null,
                valor: null,
                valorpago: null,
                juros: null,
                tipodoc: null,
                mora: null,
                parcela: null,
                conta: null,
                ccusto : null,
                serie: null,
                situacao: null,
            },

            fornecedores: [],
            contas: [],
            ccustos: [],
            tipodocs: [
                {id: 1, descricao: "cartão"}
            ],

            alert: {
                show: false,
                type: 'alert-warning',
                message: ''
            }
        }
    },

    components: {
        jtForm,
        VSelect,
        inputMoeda
    },

    validations: {
        form: {
            doc: {
                required,
                numeric
            },
            parcela: {
                required,
                numeric
            },
            juros: {
                required
            },
            valor: {
                required
            },
            valorpago: {
                required
            },
            serie: {
                required
            },
            
            agente: {
                required
            }
        }
    },

    mounted(){
        this.buscarCCustos()
        this.buscarContas()
        this.buscarFornecedores()
    },

    computed: {
        getToken(){
            return this.$store.getters.getToken
        }
    },

    methods: {
        buscarCCustos : function(){
            fetch(server + 'crud/duplicatas/centrocusto', {
                method: 'GET',
                headers: new Headers({
                    'token' : this.getToken
                })
            })
                .then(response => {
                    if(response.status == 200){
                        response.json()
                            .then(data => {
                                if(data.data){
                                    this.ccustos = data.response
                                }else{
                                    console.error('Error exception', '=>', data.message)
                                }
                            })
                            .catch(error => {
                                console.error('Error exception', '=>', error.message)
                            })
                    }else{
                        console.error('Error exception', '=>', response.statusText)
                    }
                })
                .catch(error => {
                    console.error('Error exception', '=>', error.message)
                })
        },
        
        buscarContas : function(){
            fetch(server + 'crud/duplicatas/contas/D', {
                method: 'GET',
                headers: new Headers({
                    'token' : this.getToken
                })
            })
                .then(response => {
                    if(response.status == 200){
                        response.json()
                            .then(data => {
                                if(data.data){
                                    this.contas = data.response
                                }else{
                                    console.error('Error exception', '=>', data.message)
                                }
                            })
                            .catch(error => {
                                console.error('Error exception', '=>', error.message)
                            })
                    }else{
                        console.error('Error exception', '=>', response.statusText)
                    }
                })
                .catch(error => {
                    console.error('Error exception', '=>', error.message)
                })
        },

        buscarFornecedores : function(){
            fetch(server + 'crud/duplicatas/fornecedores', {
                method: 'GET',
                headers: new Headers({
                    'token' : this.getToken
                })
            })
                .then(response => {
                    if(response.status == 200){
                        response.json()
                            .then(data => {
                                if(data.data){
                                    this.fornecedores = data.response
                                }else{
                                    console.error('Error exception', '=>', data.message)
                                }
                            })
                            .catch(error => {
                                console.error('Error exception', '=>', error.message)
                            })
                    }else{
                        console.error('Error exception', '=>', response.statusText)
                    }
                })
                .catch(error => {
                    console.error('Error exception', '=>', error.message)
                })
        },

        create: function(){
            let formErrors  = this.$v.form.$invalid

            if(formErrors === false){
                let formBody = []

                    for (let prop in this.form) {
                        if(this.form[prop] !== null){
                            let encodedKey = encodeURIComponent(prop)
                            var encodedValue

                            if([
                                'ccusto',
                                'conta',
                                'agente',
                                'tipodoc'
                            ].includes(prop)){
                                encodedValue = encodeURIComponent(this.form[prop].id)
                            }else if([
                                'emissao',
                                'vencimento',
                                'previsao'
                            ].includes(prop)){
                                // let date = this.$moment(prop ,'yyyy-mm-dd')
                                encodedValue = this.$moment(this.form[prop] ,'YYYY-MM-DD').format('DD/MM/YYYY')
                            }else{
                                encodedValue = encodeURIComponent(this.form[prop])
                            }
                            
                            
                            formBody.push(encodedKey + "=" + encodedValue)
                        }
                    }

                formBody = formBody.join("&")

                fetch(server + 'crud/duplicatas/nova-dp', {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'token' : this.getToken
                    }),
                    body: formBody
                })
                    .then(response => {
                        if(response.status == 201){
                            response.json()
                                .then(data => {
                                    if(data.data){
                                        this.alert = {
                                            show: true,
                                            type: 'success',
                                            message: 'Duplicata cadastrada.'
                                        }
                                    }else{
                                        this.alert = {
                                            show: true,
                                            type: 'warning',
                                            message: data.message
                                        }
                                    }
                                })
                                .catch(error => {
                                        this.alert = {
                                            show: true,
                                            type: 'warning',
                                            message: error.message
                                        }
                                })
                        }else{
                            this.alert = {
                                show: true,
                                type: 'danger',
                                message: response.statusText
                            }
                        }
                    })
                    .catch(error => {
                        console.error('Error', '=>', error)
                        this.alert = {
                            show: true,
                            type: 'danger',
                            message: 'Error'
                        }
                    })
            }else{
                this.alert = {
                    show: true,
                    type: 'warning',
                    message: 'Existem campos inválidos ou sem valor.'
                }
            }
        },

        closeAlert: function(){
            this.alert = {
                type: 'warning',
                message: '',
                show: false
            }
        },

        clear: function(){
            for(let prop in this.form){
                this.form[prop] = null
            }
        }
    }
}
</script>